import React, { Component } from 'react';
import { withRouter  } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { postsIds } from '../../../constants/app';
import ActionMenu from '../../utils/ActionMenu';
import { parseNumToFixed } from '../../../utils/common';

class TableStaff extends Component {
    renderThead() {
        return (
            <thead className="kt-datatable__head">
                <tr className="kt-datatable__row">
                    <th className="kt-datatable__cell" style={{ width: 'auto' }}>
                        <span>ФИО</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '100px' }}>
                        <span>Должность</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '250px' }}>
                        <span>Филиал</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '150px' }}>
                        <span>Ставка</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '150px' }}>
                        <span>Действия</span>
                    </th>
                </tr>
            </thead>
        );
    }

    getPost(postId) {
        if (!postId || isEmpty(postsIds)) return '-';
        const entity = postsIds.find((post) => post.id === postId);
        if (isEmpty(entity)) return '-';
        return entity.label || '-';
    }

    getLastRate(lastRate) {
        if (isEmpty(lastRate) || lastRate.sum == null) return 0;
        return parseNumToFixed(lastRate.sum);
    }

    getPoint(pointId) {
        if (!pointId || isEmpty(this.props.filials)) return '-';
        const entity = this.props.filials.find((point) => point.id === pointId);
        if (isEmpty(entity)) return '-';
        return this.props.renderAdress(entity) || '-';
    }
    
    renderBody() {
        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.map(item => {
                        const actions = [
                            { name: 'Удалить', icon: 'flaticon2-trash', action: () => this.props.deleteItem(item) }
                        ]
                        return (
                            <tr key={item.id} className="kt-datatable__row">
                            <td className="kt-datatable__cell" style={{ width: 'auto' }}>
                                <span>
                                    {item.name}
                                </span>
                            </td>
                            <td className="kt-datatable__cell" style={{ width: '100px' }}>
                                <span>
                                    {this.getPost(item.postId)}
                                </span>
                            </td>
                            <td className="kt-datatable__cell" style={{ width: '250px' }}>
                                <span>
                                    {this.getPoint(item.pointId)}
                                </span>
                            </td>
                            <td className="kt-datatable__cell" style={{ width: '150px' }}>
                                <span>
                                    {this.getLastRate(item.lastRate)}  
                                </span>
                            </td>
                            <td className="kt-datatable__cell" style={{ width: '150px' }}>
                                <ActionMenu actions={actions}/>
                            </td>
                        </tr>
                        )
                    }) 
                }
            </tbody>
        );
    }

    renderBodyMobile() {
        
        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.map(item => {
                        const actions = [
                            { name: 'Удалить', icon: 'flaticon2-trash', action: () => this.props.deleteItem(item) }
                        ]
                        return (
                            <tr  key={item.id} className="kt-datatable__row">
                            <div className='mobile_div_flex column padding10px'>
                                <div className='mobile_div_flex column_mobile430px'>
                                    <div style={window.innerWidth > 430 ? { width: '50%' } : { width: '100%' }}>
                                        <span>
                                           ФИО: <span style={{ color: '#000' }}>{item.name}</span>
                                        </span>
                                    </div>
                                    <div style={window.innerWidth > 430 ? { width: '50%' } : { width: '100%' }}>
                                        <span>
                                            Должность: <span style={{ color: '#000' }}>{this.getPost(item.postId)}</span>
                                        </span>
                                    </div>
                                </div>
                                <div className='mobile_div_flex column_mobile430px'>
                                    <div style={window.innerWidth > 430 ? { width: '50%' } : { width: '100%' }}>
                                        <span>
                                           Ставка: <span style={{ color: '#000' }}>{this.getLastRate(item.lastRate)}</span>
                                        </span>
                                    </div>
                                </div>
                                <div className='mobile_div_flex column_mobile430px'>
                                    <div style={{ width: '100%' }}>
                                        <span>
                                           Филиал: <span style={{ color: '#000' }}>{this.getPoint(item.pointId)}</span>
                                        </span>
                                    </div>
                                </div>
                                <div className='mobile_div_flex' style={{ width: 'calc(100% + 50px)', justifyContent: 'flex-end' }}>
                                        <ActionMenu actions={actions}/>
                                </div>
                            </div>
                        </tr>
                        )
                    }) 
                }
            </tbody>
        );
    }

    render() {
        if (this.props.items.length === 0) {
            return (
                <div>Сотрудников не найдено</div>
            );
        }

        if(window.innerWidth > 860)
            return (
                <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                    {this.renderThead()}
                    {this.renderBody()}
                </table>
            );

        return (
            <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                {this.renderBodyMobile()}
            </table>
        );
    }
}

export default withRouter(TableStaff);